import { createTheme } from '@mui/material/styles';

// Light Theme
const lightTheme = createTheme({
    palette: {
        mode: 'light',
        primary: {
            main: '#3c50b4',
        },
        secondary: {
            main: '#4caf50'
        },
        ternary: {
            main: '#A9ABB5',
            DashboardIcon: '#757575'
        },

        action: {
            disabledBackground: '#e0e0e0'
        },
        datagrid: {
            headerColor: "#0000008A",
            headerBgcolor: "#ffffff"
        },
        icon: '#333',
        iconBlack: '#212121',
        messageBoxBg: '#f4f4f4'
    },
    components: {
        MuiCssBaseline: {
            styleOverrides: {
                body: {
                    backgroundColor: '#fafafa',
                    color: '#000',
                },
                '.casescreen': {
                    marginRight: '7%',
                    marginLeft: '7%',
                },
                '@media only screen and (max-width: 1270px)': {
                    '.casescreen': {
                        marginRight: '0%',
                        marginLeft: '0%',
                    },
                },
                '.MuiTableRow-root:hover': {
                    backgroundColor: '#eeeeee',
                },
                '.MuiTableContainer-root': {
                    overflow: 'auto',
                    // maxHeight: '565px',
                },
                '.MuiTablePagination-root, .MuiTablePagination-select': {
                    color: '#212121 !important',
                },
                '.MuiTabs-root': {
                    display: 'flex',
                    backgroundColor: '#ffffff !important',
                    overflow: 'hidden',
                    position: 'relative',
                    // boxShadow: '0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12) !important',
                },
                '.MuiFormLabel-asterisk': {
                    color: 'red !important',
                },
            },
        },
    },
});

// Dark Theme
const darkTheme = createTheme({
    palette: {
        mode: 'dark',
        primary: {
            main: '#90caf9',
        },
        secondary: {
            main: '#4caf50',
        },
        ternary: {
            main: '#A9ABB5',
        },

        action: {
            active: '#ffffff',
            hover: 'rgba(255, 255, 255, 0.08)',
            disabledBackground: '#e0e0e0'
        },
        background: {
            default: '#121212',
            paper: '#1e1e1e',
        },
        datagrid: {
            headerColor: "#888",
            headerBgcolor: "#1a1a1a"
        },
        icon: '#ffffff',
        iconBlack: '#ffffff',
        messageBoxBg: '#040406'
    },
    components: {
        MuiCssBaseline: {
            styleOverrides: {
                body: {
                    backgroundColor: '#121212',
                    color: '#fff',
                },
                '.casescreen': {
                    marginRight: '7%',
                    marginLeft: '7%',
                },
                '@media only screen and (max-width: 1270px)': {
                    '.casescreen': {
                        marginRight: '0%',
                        marginLeft: '0%',
                    },
                },
                '.MuiTableRow-root:hover': {
                    backgroundColor: 'rgba(255, 255, 255, 0.08) !important',
                },
                '.MuiTableContainer-root': {
                    overflow: 'auto',
                    maxHeight: '565px',
                },
                '.MuiTablePagination-root, .MuiTablePagination-select': {
                    color: '#ffffff !important',
                },
                '.MuiTabs-root': {
                    display: 'flex',
                    backgroundColor: '#1e1e1e !important',
                    overflow: 'hidden',
                    position: 'relative',
                    boxShadow: '0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12) !important',
                },
                // Fix for white-on-white text fields in dark mode
                '.MuiInputBase-root': {
                    color: '#fff !important',
                    backgroundColor: 'transparent !important',
                    '& input[type="datetime-local"], & input[type="date"], & input[type="time"]': {
                        colorScheme: 'dark !important',
                        '&::-webkit-calendar-picker-indicator': {
                            filter: 'brightness(0) invert(1) !important',
                        }
                    }
                },
                '.MuiInput-underline:before': {
                    borderBottomColor: 'rgba(255, 255, 255, 0.7) !important',
                },
                '.MuiInputLabel-root': {
                    color: 'rgba(255, 255, 255, 0.7) !important',
                },
                '.MuiOutlinedInput-notchedOutline': {
                    borderColor: 'rgba(255, 255, 255, 0.23) !important',
                },
                '.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: 'rgba(255, 255, 255, 0.87) !important',
                },
                '.MuiIconButton-root': {
                    color: 'inherit',
                },
                // Correctly color browser-default date/time icons (calendar and clock) in dark mode
                'input::-webkit-calendar-picker-indicator': {
                    cursor: 'pointer',
                    filter: 'brightness(0) invert(1) !important', // Neutralize then invert to white
                },
                'input[type="datetime-local"], input[type="date"], input[type="time"]': {
                    colorScheme: 'dark !important',
                },
                // Global fix for MUI X Charts visibility in dark mode
                '.MuiChartsAxis-label, .MuiChartsAxis-tickLabel': {
                    fill: '#fff !important',
                },
                '.MuiChartsAxis-line, .MuiChartsAxis-tick': {
                    stroke: 'rgba(255, 255, 255, 0.3) !important',
                },
                '.MuiChartsGrid-line': {
                    stroke: 'rgba(255, 255, 255, 0.1) !important',
                },
                '.MuiChartsLegend-root text': {
                    fill: '#fff !important',
                },
                '.MuiFormLabel-asterisk': {
                    color: 'red !important',
                }
            },
        },
        MuiSvgIcon: {
            styleOverrides: {
                root: {
                    color: 'inherit',
                },
            },
        },
        MuiPaper: {
            styleOverrides: {
                root: {
                    backgroundImage: 'none',
                    backgroundColor: '#1e1e1e',
                    color: '#fff',
                },
            },
        },
        MuiCard: {
            styleOverrides: {
                root: {
                    backgroundColor: '#1e1e1e',
                    color: '#fff',
                },
            },
        },
        MuiTableCell: {
            styleOverrides: {
                head: {
                    backgroundColor: '#1a1a1a',
                    color: '#888',
                    borderBottom: '1px solid #333',
                },
            },
        },
        MuiDialog: {
            styleOverrides: {
                paper: {
                    backgroundColor: '#1e1e1e',
                    color: '#fff',
                },
            },
        },
        MuiAccordion: {
            styleOverrides: {
                root: {
                    backgroundColor: '#1e1e1e',
                    color: '#fff',
                    '&:before': {
                        display: 'none',
                    },
                },
            },
        },
        MuiMenu: {
            styleOverrides: {
                paper: {
                    backgroundColor: '#1e1e1e',
                    color: '#fff',
                },
            },
        },
    },
});

export { lightTheme, darkTheme };
